import type { Course } from '@openclassrooms/sdk-web';

import { CHAPTER_STATUSES, STATUS_PROMOTION } from '../_constants/learningStatuses';

interface Params {
  id: number;
  initialStatus?: (typeof CHAPTER_STATUSES)[number];
  isOnHomePage: boolean;
  course: Course;
  currentChapterId: number;
}

type LearningStatus = {
  status: (typeof CHAPTER_STATUSES)[number];
};

const useChapterLearningStatus = ({
  id,
  initialStatus = 'not started',
  isOnHomePage,
  course,
  currentChapterId,
}: Params): LearningStatus => {
  const { userIsFollowingCourse: isFollowingCourse, learningActivityStatus: courseLearningStatus } =
    course || {};

  if (!isFollowingCourse && isOnHomePage) {
    return { status: STATUS_PROMOTION };
  }

  const isChapterInProgress =
    courseLearningStatus === 'in progress' &&
    currentChapterId === id &&
    initialStatus === 'not started';

  if (isChapterInProgress) {
    return { status: 'in progress' };
  }

  return { status: initialStatus };
};

export default useChapterLearningStatus;
